module.exports = "/assets/data/d6726a5352047edb34329a991d32cba4-CF62.data.json";